import pxToRem from "../utils/pxToRem";

export const spacing = {
    0: '0',
    12: pxToRem(12),
    18: pxToRem(18),
    20: pxToRem(20),
    24: pxToRem(24),
    32: pxToRem(32),
    40: pxToRem(40),
    60: pxToRem(60),
    64: pxToRem(64),
    120: pxToRem(120),
};